


































import {Component, Prop, Vue} from 'vue-property-decorator'
import ListItem from '@/components/list/ListItem.vue'
import {Divider} from 'element-ui'
import {Status} from '@/store/modules/issue/types'

@Component({
  components: {ListItem, [Divider.name]: Divider},
})
export default class ConfirmListItem extends Vue {
  @Prop({default: '', type: String}) title: string
  @Prop({default: '', type: String}) description: string
  @Prop({default: '', type: String}) status: Status | 'loading'
}
